"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = close;
exports.CLOSE_MENU = void 0;
var CLOSE_MENU = "client/hamburger-menu/CLOSE_MENU";
exports.CLOSE_MENU = CLOSE_MENU;

function close() {
  return {
    "type": CLOSE_MENU
  };
}